import { Box } from "@mui/material";
import BuildingInfo from "../../../environment-page-components/BuildingInfo";
import SupplierInfo from "../../../environment-page-components/SupplierInfo";
import { useState, useEffect } from "react";
import { Building } from "../../../db_access/building";
import { ORG_PALETTE } from "../../../theme/style/organizationPalette";

const BuildingInfoTab = ({ building }) => {
  // Local state for building
  const [buildingData, setBuildingData] = useState(building);
  
  // Sync state when prop changes (Crucial for ValidationGrid selection)
  useEffect(() => {
    if (building) {
      setBuildingData(building);
    }
  }, [building]);

  // Optional: refetch building from backend to keep in sync
  const refreshBuildingData = () => {
    Building.get_by_id(building.id)
      .then(res => res.json())
      .then(data => setBuildingData(data))
      .catch(err => console.error("Error fetching building:", err));
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: ORG_PALETTE.spacing.sectionGap }}>
      {buildingData && (
        <>
          <BuildingInfo building={buildingData} setBuilding={setBuildingData} />
          <SupplierInfo
            type="building"
            selectedRow={buildingData}
            setBuildingData={setBuildingData}   // update local state immediately
            refreshBuildingData={refreshBuildingData} // optional refetch if needed
          />
        </>
      )}
    </Box>
  );
};

export default BuildingInfoTab;

